import { DEFAULT_RANGES } from '@/lib/ranges';

export default function RangeChips({ value, onChange, testidPrefix = 'range' }) {
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={`${testidPrefix}-chips`}>
      <button data-testid={`${testidPrefix}-all`} onClick={() => onChange('all', null)}
        className={`px-3 py-1.5 rounded-md text-[11px] uppercase tracking-widest border transition-colors ${value === 'all' ? 'bg-primary text-white border-primary' : 'border-border/70 hover:border-primary text-muted-foreground'}`}>
        All time
      </button>
      {DEFAULT_RANGES.map(r => (
        <button key={r.key} data-testid={`${testidPrefix}-${r.key}`} onClick={() => onChange(r.key, r.get())}
          className={`px-3 py-1.5 rounded-md text-[11px] uppercase tracking-widest border transition-colors ${value === r.key ? 'bg-primary text-white border-primary' : 'border-border/70 hover:border-primary text-muted-foreground'}`}>
          {r.label}
        </button>
      ))}
    </div>
  );
}
